import { RootState } from "config/reducers";
import { createSelector } from '@reduxjs/toolkit';

export const getRecaptchaPublicKey = createSelector(
    (state: RootState) => state.config,
    config => config.recaptchaPublicKey
);

export const getCompagnies = createSelector(
    (state: RootState) => state.config,
    config => config.companies
);